
<div
    class  = "pa-2 pr-1 pb-3 navigation-entries"
    :class = "compact ? ' pl-3' : ' pl-2'"
>
    <!-- fab button -->
    <div
        class  = "navigation-fab"
        :style = "fabPosition"
    >
        <v-btn
            color       = "primary"
            :ripple     = "false"
            @click.stop = "onCompact"
            fab
            x-small
            absolute
            bottom
            left
        >
            <v-icon>{{ fabIcon }} </v-icon>
        </v-btn>
    </div>
    <!-- fab button -->

    <div class="v-flex mt-1 mr-4 mb-3">
        <div class="pt-3 pl-2 step-name" v-if="compact">
            {{ stepName }}
        </div>

        <v-spacer v-if="compact" />

        <div :class="compact ? '' : 'w-100'">
            <v-text-field
                v-model   = "search"
                class     = "mb-2 ml-2 mt-0 pt-1"
                :outlined = "compact"
                :style    = "searchWidth"
                @input    = "onSearch"
                dense
                hide-details
            >
                <template v-slot:prepend-inner>
                    <v-icon v-if="compact" size="20" class="ml-2" style="margin-top: 2px">mdi-magnify</v-icon>
                </template>
                <template v-slot:append>
                    <v-icon v-if="!compact" size="20" class="ml-2" style="margin-top: 2px">mdi-magnify</v-icon>
                </template>
            </v-text-field>
        </div>
    </div>

    <div class="scroll-area">
        <div v-if="!compact">
            <a
                v-for  = "(unit, index) in filteredSites"
                :key   = "unit.id"
                @click = "onSelect(unit)"
            >
                <v-hover v-slot="{ hover }" >
                    <p-inc-navigation-entry
                        class     = "mr-1 mb-2 ml-2"
                        :class    = "index < filteredSites.length-1 ? 'mb-1 ' : ' '"
                        :incident = "incident"
                        :unit     = "unit"
                        :hover    = "hover"
                        @remove   = "onRemove"
                    />
                </v-hover>
            </a>
        </div>

        <div
            v-if   = "compact"
            :style = "'height: ' + (35 + sites.length * 40) + 'px;'"
        >
            <p-inc-navigation-entry-invoice
                v-if    = "isInvoice"
                :header = "true"
            />

            <p-inc-navigation-entry-issue
                v-if    = "isIssue"
                :header = "true"
            />

            <p-inc-navigation-entry-repair
                v-if    = "isRepair"
                :header = "true"
            />

            <p-inc-navigation-entry-assessment
                v-if    = "isAssessment"
                :header = "true"
            />

            <p-inc-navigation-entry-assessment-invoice
                v-if    = "isAssessmentInvoice"
                :header = "true"
            />

            <a
                v-for  = "(unit, index) in filteredSites"
                :key   = "unit.id"
                @click = "onSelect(unit)"
            >
                 <p-inc-navigation-entry-invoice
                    v-if        = "isInvoice"
                    class       = "ma-0 pa-0 mr-1 ml-2"
                    :entry      = "entry(unit, step)"
                    :removeable = "incident.data.length > 0"
                    :border-type="borderType(index)"
                    @remove     = "onRemove"
                />

                <p-inc-navigation-entry-issue
                    v-if        = "isIssue"
                    class       = "ma-0 pa-0 mr-1 ml-2"
                    :entry      = "entry(unit, step)"
                    :removeable = "incident.data.length > 0"
                    :border-type="borderType(index)"
                    @remove     = "onRemove"
                />

                <p-inc-navigation-entry-maintenance
                    v-if        = "isMaintenance"
                    class       = "ma-0 pa-0 mr-1 ml-2"
                    :step-data  = "stepData(step)"
                    :entry      = "entry(unit, step)"
                    :removeable = "incident.data.length > 0"
                    :border-type="borderType(index)"
                    @remove     = "onRemove"
                />

                <p-inc-navigation-entry-repair
                    v-if        = "isRepair"
                    class       = "ma-0 pa-0 mr-1 ml-2"
                    :entry      = "entry(unit, step)"
                    :bid        = "bid(unit, step)"
                    :removeable = "incident.data.length > 0"
                    :border-type="borderType(index)"
                    @remove     = "onRemove"
                />

                <p-inc-navigation-entry-assessment
                    v-if        = "isAssessment"
                    class       = "ma-0 pa-0 mr-2 ml-2"
                    :entry      = "entry(unit, step)"
                    :removeable = "incident.data.length > 0"
                    :border-type="borderType(index)"
                    @remove     = "onRemove"
                />

                <p-inc-navigation-entry-assessment-invoice
                    v-if        = "isAssessmentInvoice"
                    class       = "ma-0 pa-0 mr-1 ml-2"
                    :entry      = "entry(unit, step)"
                    :removeable = "incident.data.length > 0"
                    :border-type="borderType(index)"
                    @remove     = "onRemove"
                />
            </a>
        </div>
    </div>
 </div>
